import LayoutGrid from "vue-layout-grid"
import TimeRange from "vue-time-range"
import { sync } from "vuex-router-sync"
import App from "./App.vue"
import { RouterModuleNamespace } from "./consts"
import Vue from "./plugins"
import router from "./router"
import UAcsLogin from "u-acs-login"
import store from "./store"
import { httpToWs } from "@/utils/url"
import VueNativeSock from "vue-native-websocket"

Vue.config.productionTip = false

Vue.use(
    VueNativeSock,
    httpToWs(`${process.env.VUE_APP_BASE_URL}/ws/subscriber`),
    {
        store,
        connectManually: true,
        format: "json",
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 3000,
    }
)

Vue.use(TimeRange, { store })
Vue.use(LayoutGrid, { store })
Vue.use(UAcsLogin, { store })

sync(store, router, { moduleName: RouterModuleNamespace })

new Vue({
    router,
    store,
    render: h => h(App),
})
    .$mount("#app")
    .$connect()
